import { useNavigate } from "react-router-dom";

function EmptyCart() {
    const navigate = useNavigate();

    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <h2 style={styles.title}>Your Cart is Empty</h2>
                <p style={styles.subtitle}>
                    Start booking your favorite courts
                </p>

                <button
                    style={styles.button}
                    onClick={() => navigate("/search")}
                >
                    Browse Courts
                </button>
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "80px",
    },

    card: {
        width: "100%",
        maxWidth: "420px",
        padding: "40px 30px",
        borderRadius: "20px",
        background: "rgba(0,40,70,0.85)",
        border: "1px solid rgba(0,255,150,0.3)",
        backdropFilter: "blur(10px)",
        textAlign: "center",
        color: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
    },

    title: {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "10px",
    },

    subtitle: {
        color: "#ccc",
        marginBottom: "25px",
        fontSize: "14px",
    },

    button: {
        padding: "12px 20px",
        borderRadius: "25px",
        border: "none",
        fontWeight: "bold",
        background: "linear-gradient(90deg, #00f5a0, #00d9f5)",
        cursor: "pointer",
        transition: "0.3s",
    },
};

export default EmptyCart;